module.exports = __webpack_public_path__ + "static/voices_votes-3a1175eb11bfd19cec919467d6eed399.wav";